import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout/layout';
import Seo from '../components/seo';
import useLanguage from '../hooks/useLanguage';

import { BlogMainScreen, BlogItems, CrumbsNav } from '../components/Pages/Blog';


import { blogStatic } from '../db/blogStatic';

const blogPage = ({data}) => {

  const blogDatas = data.strapiBlog
  const langToggle = useLanguage;

  return (
    <Layout>
      <Seo 
        title={langToggle(blogDatas.seo_title_ua, blogDatas.seo_title_ru)}
        description={langToggle(blogDatas.seo_description_ua, blogDatas.seo_description_ru)} 
      />
      <BlogMainScreen 
        mainData={blogDatas.main} 
        categoryData={data.allStrapiCategory.nodes}
      />
      <BlogItems articlesData={data.allStrapiBlogArticles.edges} />
      <CrumbsNav crumbsData={blogStatic.crumbs_nav} />
    </Layout>
  );
};

export default blogPage;

export const query = graphql`
  query Blog($language: String!) {
      strapiBlog {
        seo_title_ua
        seo_title_ru
        seo_description_ua
        seo_description_ru
        main {
          title_01_ua
          title_02_ua
          title_01_ru
          title_02_ru
        }
    }
    allStrapiCategory {
      nodes {
        title_ua
        title_ru
        slug
      }
    }
    allStrapiBlogArticles {
      edges {
      node {
        id
        slug
        article {
          id
          title_ua
          title_ru
          time_ua
          time_ru
          date
        }
        category {
          id
          slug
          title_ua
          title_ru
        }
      }
    }
    }
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
